var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"relative w-full h-full"},[(_vm.loading)?_c('div',{staticClass:"skeleton-loader",class:_vm.imgClass,style:({
            ..._vm.skeletonBaseStyle,
            ..._vm.imgStyle,
        })}):_vm._e(),(_vm.isVisible)?_c('img',{staticClass:"image object-cover",class:[_vm.imgClass, { hidden: _vm.loading, 'fade-in': !_vm.loading }],staticStyle:{"border-radius":"0.5rem"},style:(_vm.imgStyle),attrs:{"src":_vm.src,"alt":_vm.alt},on:{"load":_vm.onLoad,"error":_vm.onError}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }